
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import SectionHeadline from './section-headline'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "sectionheadline"
    }}>{`SectionHeadline`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Landmarks`}</p>
    <hr />
    <h2 {...{
      "id": "section-headline"
    }}>{`Section headline`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For titling sections.`}</p>
    <Playground __position={1} __code={'<SectionHeadline headline=\"Section headline\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionHeadline
    }} mdxType="Playground">
  <SectionHeadline headline='Section headline' mdxType="SectionHeadline" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "section-headline-with-link"
    }}>{`Section headline with link`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For titling and linking sections.`}</p>
    <Playground __position={3} __code={'<SectionHeadline headline=\"Section headline\" href=\"/\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionHeadline
    }} mdxType="Playground">
  <SectionHeadline headline='Section headline' href='/' mdxType="SectionHeadline" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "section-headline-heavy"
    }}>{`Section headline (heavy)`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`For titling sections with hierarchical importance.`}</p>
    <Playground __position={5} __code={'<SectionHeadline headline=\"Section headline\" heavy />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionHeadline
    }} mdxType="Playground">
  <SectionHeadline headline='Section headline' heavy mdxType="SectionHeadline" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "section-headline-with-link-heavy"
    }}>{`Section headline with link (heavy)`}</h2>
    <h3 {...{
      "id": "description-3"
    }}>{`Description`}</h3>
    <p>{`For titling and linking sections with hierarchical importance.`}</p>
    <Playground __position={7} __code={'<SectionHeadline headline=\"Section headline\" heavy href=\"/\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionHeadline
    }} mdxType="Playground">
  <SectionHeadline headline='Section headline' heavy href='/' mdxType="SectionHeadline" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "section-headline--rule-emphasised"
    }}>{`Section headline + rule (emphasised)`}</h2>
    <h3 {...{
      "id": "description-4"
    }}>{`Description`}</h3>
    <p>{`A graphic device for titling sections.`}</p>
    <Playground __position={9} __code={'<SectionHeadline headline=\"Section headline\" rule=\"emphasised\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionHeadline
    }} mdxType="Playground">
  <SectionHeadline headline='Section headline' rule='emphasised' mdxType="SectionHeadline" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "section-headline-with-link--rule-emphasised"
    }}>{`Section headline with link + rule (emphasised)`}</h2>
    <h3 {...{
      "id": "description-5"
    }}>{`Description`}</h3>
    <p>{`A graphic device for titling and linking sections.`}</p>
    <Playground __position={11} __code={'<SectionHeadline headline=\"Section headline\" rule=\"emphasised\" href=\"/\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionHeadline
    }} mdxType="Playground">
  <SectionHeadline headline='Section headline' rule='emphasised' href='/' mdxType="SectionHeadline" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "section-headline--rule-heavy"
    }}>{`Section headline + rule (heavy)`}</h2>
    <h3 {...{
      "id": "description-6"
    }}>{`Description`}</h3>
    <p>{`A graphic device for titling sections with hierarchical importance.`}</p>
    <Playground __position={13} __code={'<SectionHeadline headline=\"Section headline\" heavy rule=\"heavy\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionHeadline
    }} mdxType="Playground">
  <SectionHeadline headline='Section headline' heavy rule='heavy' mdxType="SectionHeadline" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "section-headline-with-link--rule-heavy"
    }}>{`Section headline with link + rule (heavy)`}</h2>
    <h3 {...{
      "id": "description-7"
    }}>{`Description`}</h3>
    <p>{`A graphic device for titling and linking sections with hierarchical importance.`}</p>
    <Playground __position={15} __code={'<SectionHeadline headline=\"Section headline\" heavy rule=\"heavy\" href=\"/\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionHeadline
    }} mdxType="Playground">
  <SectionHeadline headline='Section headline' heavy rule='heavy' href='/' mdxType="SectionHeadline" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "section-headline-and-subheadline--rule-emphasised"
    }}>{`Section headline and subheadline + rule (emphasised)`}</h2>
    <h3 {...{
      "id": "description-8"
    }}>{`Description`}</h3>
    <p>{`A graphic device for titling sections. Include a subheadline for additional contextual information.`}</p>
    <Playground __position={17} __code={'<SectionHeadline\n  headline=\"Section headline\"\n  subheadline=\"Section subheadline\"\n  rule=\"emphasised\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionHeadline
    }} mdxType="Playground">
  <SectionHeadline headline='Section headline' subheadline='Section subheadline' rule='emphasised' mdxType="SectionHeadline" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "section-headline-and-subheadline-with-link--rule-emphasised"
    }}>{`Section headline and subheadline with link + rule (emphasised)`}</h2>
    <h3 {...{
      "id": "description-9"
    }}>{`Description`}</h3>
    <p>{`A graphic device for titling and linking sections. Include a subheadline for additional contextual information.`}</p>
    <Playground __position={19} __code={'<SectionHeadline\n  headline=\"Section headline\"\n  subheadline=\"Section subheadline\"\n  rule=\"emphasised\"\n  href=\"/\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionHeadline
    }} mdxType="Playground">
  <SectionHeadline headline='Section headline' subheadline='Section subheadline' rule='emphasised' href='/' mdxType="SectionHeadline" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "section-headline-and-subheadline--rule-heavy"
    }}>{`Section headline and subheadline + rule (heavy)`}</h2>
    <h3 {...{
      "id": "description-10"
    }}>{`Description`}</h3>
    <p>{`A graphic device for titling sections with hierarchical importance. Include a subheadline for additional contextual information.`}</p>
    <Playground __position={21} __code={'<SectionHeadline\n  headline=\"Section headline\"\n  subheadline=\"Section subheadline\"\n  heavy\n  rule=\"heavy\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionHeadline
    }} mdxType="Playground">
  <SectionHeadline headline='Section headline' subheadline='Section subheadline' heavy rule='heavy' mdxType="SectionHeadline" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "section-headline-and-subheadline-with-link--rule-heavy"
    }}>{`Section headline and subheadline with link + rule (heavy)`}</h2>
    <h3 {...{
      "id": "description-11"
    }}>{`Description`}</h3>
    <p>{`A graphic device for titling and linking sections with hierarchical importance. Include a subheadline for additional contextual information.`}</p>
    <Playground __position={23} __code={'<SectionHeadline\n  headline=\"Section headline\"\n  subheadline=\"Section subheadline\"\n  heavy\n  rule=\"heavy\"\n  href=\"/\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionHeadline
    }} mdxType="Playground">
  <SectionHeadline headline='Section headline' subheadline='Section subheadline' heavy rule='heavy' href='/' mdxType="SectionHeadline" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "section-headline--rule-accent"
    }}>{`Section headline + rule (accent)`}</h2>
    <h3 {...{
      "id": "description-12"
    }}>{`Description`}</h3>
    <p>{`A unique graphic device for titling sections.`}</p>
    <p><strong parentName="p">{`To ensure section headlines with accent rules are effective, use sparingly and with distinct groups of content. Most content is best sectioned with a clear typographic hierarchy, clear of ornament.`}</strong></p>
    <p><strong parentName="p">{`Use short and descriptive headlines:  one or two words, at most five.`}</strong></p>
    <Playground __position={25} __code={'<SectionHeadline headline=\"Section headline\" rule=\"accent\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionHeadline
    }} mdxType="Playground">
  <SectionHeadline headline='Section headline' rule='accent' mdxType="SectionHeadline" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "section-headline-with-link--rule-accent"
    }}>{`Section headline with link + rule (accent)`}</h2>
    <h3 {...{
      "id": "description-13"
    }}>{`Description`}</h3>
    <p>{`A unique graphic device for titling and linking sections.`}</p>
    <p><strong parentName="p">{`To ensure section headlines with accent rules are effective, use sparingly and with distinct groups of content. Most content is best sectioned with a clear typographic hierarchy, clear of ornament.`}</strong></p>
    <p><strong parentName="p">{`Use short and descriptive headlines:  one or two words, at most five.`}</strong></p>
    <Playground __position={27} __code={'<SectionHeadline headline=\"Section headline\" rule=\"accent\" href=\"/\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionHeadline
    }} mdxType="Playground">
  <SectionHeadline headline='Section headline' rule='accent' href='/' mdxType="SectionHeadline" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "section-headline--rule-inverse-accent"
    }}>{`Section headline + rule (inverse, accent)`}</h2>
    <h3 {...{
      "id": "description-14"
    }}>{`Description`}</h3>
    <p>{`A unique graphic device for titling sections.`}</p>
    <p><strong parentName="p">{`To ensure section headlines with accent rules are effective, use sparingly and with distinct groups of content. Most content is best sectioned with a clear typographic hierarchy, clear of ornament.`}</strong></p>
    <p><strong parentName="p">{`Use short and descriptive headlines:  one or two words, at most five.`}</strong></p>
    <Playground __position={29} __code={'<SectionHeadline headline=\"Section headline\" rule=\"accent\" inverse />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionHeadline
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <SectionHeadline headline='Section headline' rule='accent' inverse mdxType="SectionHeadline" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "section-headline-with-link--rule-inverse-accent"
    }}>{`Section headline with link + rule (inverse, accent)`}</h2>
    <h3 {...{
      "id": "description-15"
    }}>{`Description`}</h3>
    <p>{`A unique graphic device for titling and linking sections.`}</p>
    <p><strong parentName="p">{`To ensure section headlines with accent rules are effective, use sparingly and with distinct groups of content. Most content is best sectioned with a clear typographic hierarchy, clear of ornament.`}</strong></p>
    <p><strong parentName="p">{`Use short and descriptive headlines:  one or two words, at most five.`}</strong></p>
    <Playground __position={31} __code={'<SectionHeadline headline=\"Section headline\" rule=\"accent\" inverse href=\"/\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionHeadline
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <SectionHeadline headline='Section headline' rule='accent' inverse href='/' mdxType="SectionHeadline" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "section-headline-and-subheadline--rule-accent"
    }}>{`Section headline and subheadline + rule (accent)`}</h2>
    <h3 {...{
      "id": "description-16"
    }}>{`Description`}</h3>
    <p>{`A unique graphic device for titling sections. Include a subheadline for additional contextual information.`}</p>
    <Playground __position={33} __code={'<SectionHeadline\n  headline=\"Section headline\"\n  subheadline=\"Section subheadline\"\n  rule=\"accent\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionHeadline
    }} mdxType="Playground">
  <SectionHeadline headline='Section headline' subheadline='Section subheadline' rule='accent' mdxType="SectionHeadline" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "section-headline-and-subheadline-with-link--rule-accent"
    }}>{`Section headline and subheadline with link + rule (accent)`}</h2>
    <h3 {...{
      "id": "description-17"
    }}>{`Description`}</h3>
    <p>{`A unique graphic device for titling and linking sections. Include a subheadline for additional contextual information.`}</p>
    <Playground __position={35} __code={'<SectionHeadline\n  headline=\"Section headline\"\n  subheadline=\"Section subheadline\"\n  rule=\"accent\"\n  href=\"/\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionHeadline
    }} mdxType="Playground">
  <SectionHeadline headline='Section headline' subheadline='Section subheadline' rule='accent' href='/' mdxType="SectionHeadline" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "section-headline-and-subheadline--rule-inverse-accent"
    }}>{`Section headline and subheadline + rule (inverse, accent)`}</h2>
    <h3 {...{
      "id": "description-18"
    }}>{`Description`}</h3>
    <p>{`A unique graphic device for titling sections. Include a subheadline for additional contextual information.`}</p>
    <Playground __position={37} __code={'<SectionHeadline\n  headline=\"Section headline\"\n  subheadline=\"Section subheadline\"\n  rule=\"accent\"\n  inverse\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionHeadline
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <SectionHeadline headline='Section headline' subheadline='Section subheadline' rule='accent' inverse mdxType="SectionHeadline" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "section-headline-and-subheadline-with-link--rule-inverse-accent"
    }}>{`Section headline and subheadline with link + rule (inverse, accent)`}</h2>
    <h3 {...{
      "id": "description-19"
    }}>{`Description`}</h3>
    <p>{`A unique graphic device for titling and linking sections. Include a subheadline for additional contextual information.`}</p>
    <Playground __position={39} __code={'<SectionHeadline\n  headline=\"Section headline\"\n  subheadline=\"Section subheadline\"\n  rule=\"accent\"\n  inverse\n  href=\"/\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionHeadline
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <SectionHeadline headline='Section headline' subheadline='Section subheadline' rule='accent' inverse href='/' mdxType="SectionHeadline" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={SectionHeadline} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;